import {
  BcAttemptState,
  getScoringStep,
  hasBcScore,
  ScoringStep,
  type ScoringState,
} from "@/features/scoring";
import {
  OfferStatus,
  type CreditOffer,
  type OfferRequest,
} from "@/features/offer/types";
import { hasAvailableOffer } from "@/lib/offerUtils";
import type { OnboardingFacts } from "../types/chat";

// The raw backend values the chat decides on.
export interface OnboardingFactSources {
  hasActiveLoan: boolean;
  isOnboardingCompleted: boolean;
  isEmailSaved: boolean;
  isEmailVerified: boolean;
  isTermsAccepted: boolean;
  isBcTermsAccepted: boolean;
  hasDeclaredIncome: boolean;
  scoringState: ScoringState | undefined;
  isKycValid: boolean;
  isKycFailed: boolean;
  isQuestionnaireCompleted: boolean;
  isProofOfIncomeProcessing: boolean;
  hasFinalOffer: boolean;
  offer: OfferRequest | undefined;
  creditOffers: CreditOffer[] | undefined;
}

export const buildOnboardingFacts = (
  sources: OnboardingFactSources,
): OnboardingFacts => ({
  hasActiveLoan: sources.hasActiveLoan,
  isCnpCompleted: sources.isOnboardingCompleted,
  isEmailSaved: sources.isEmailSaved,
  isEmailVerified: sources.isEmailVerified,
  isTermsAccepted: sources.isTermsAccepted,
  isBcTermsAccepted: sources.isBcTermsAccepted,
  hasDeclaredIncome: sources.hasDeclaredIncome,
  isScoringDone:
    getScoringStep(sources.scoringState, sources.isKycValid) ===
    ScoringStep.Done,
  hasBcScore: hasBcScore(sources.scoringState),
  isBcPhoneMissing:
    sources.scoringState?.bcAttemptState === BcAttemptState.NoPhoneRegistered,
  isKycValid: sources.isKycValid,
  isKycFailed: sources.isKycFailed,
  isQuestionnaireCompleted: sources.isQuestionnaireCompleted,
  isProofOfIncomeProcessing: sources.isProofOfIncomeProcessing,
  hasFinalOffer: sources.hasFinalOffer,
  offerRequestStatus: sources.offer?.status ?? null,
  isOfferExpired:
    !!sources.offer?.isExpired &&
    (sources.offer.status === OfferStatus.Complete ||
      sources.offer.status === OfferStatus.NoOfferAvailable),
  hasAvailableOffer: hasAvailableOffer(sources.creditOffers),
});
